module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row border-bottom white-bg dashboard-header"
  }, [_vm._m(0), _vm._v(" "), (_vm.pluginEnabled) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group pull-right"
  }, [_c('label', [_vm._v("Station")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "Select"
    },
    model: {
      value: (_vm.currentStation),
      callback: function($$v) {
        _vm.currentStation = $$v
      },
      expression: "currentStation"
    }
  }, _vm._l((_vm.stations), function(station) {
    return _c('el-option', {
      key: station.id,
      attrs: {
        "label": station.title,
        "value": station.id
      }
    })
  }), 1)], 1)]) : _vm._e()]), _vm._v(" "), (_vm.pluginEnabled) ? _c('div', {
    staticClass: "wrapper wrapper-content animated fadeInRight"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'h:00 a'),
      "unit": 'Hour',
      "unitClass": 'label-success',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'hour',
      "received": _vm.chartsData['hour-stats'].total,
      "growth": _vm.chartsData['hour-stats'].growth,
      "stats": _vm.chartsData['hour-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'hour'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'hour'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'hour'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['hour-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'dddd Do'),
      "unit": 'Day',
      "unitClass": 'label-info',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'day',
      "received": _vm.chartsData['day-stats'].total,
      "growth": _vm.chartsData['day-stats'].growth,
      "stats": _vm.chartsData['day-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'day'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'day'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'day'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['day-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'MMMM'),
      "unit": 'Month',
      "unitClass": 'label-primary',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'month',
      "received": _vm.chartsData['month-stats'].total,
      "growth": _vm.chartsData['month-stats'].growth,
      "stats": _vm.chartsData['month-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'month'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'month'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'month'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['month-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('analytics-unit-block', {
    attrs: {
      "period": _vm._f("moment")(_vm.selectedDate, 'YYYY'),
      "unit": 'Year',
      "unitClass": 'label-danger',
      "description": 'Estimated revenue',
      "selected": _vm.selectedPeriod === 'year',
      "received": _vm.chartsData['year-stats'].total,
      "growth": _vm.chartsData['year-stats'].growth,
      "stats": _vm.chartsData['year-stats'].points
    },
    on: {
      "previous": function($event) {
        return _vm.$emit('previous', {
          unit: 'year'
        })
      },
      "next": function($event) {
        return _vm.$emit('next', {
          unit: 'year'
        })
      }
    },
    nativeOn: {
      "click": function($event) {
        return _vm.$emit('changePeriod', {
          unit: 'year'
        })
      }
    }
  }, [(!Boolean(_vm.chartsData['year-stats'].points.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AnalyticsUnitBlock'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "480"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Engagement and revenue over time")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processEngagementsVsRevenue.length)) ? _c('analytics-time-series-area-chart', {
    attrs: {
      "data": _vm.processEngagementsVsRevenue,
      "unit": _vm.units[_vm.units.indexOf(_vm.selectedPeriod) - 1],
      "showLegend": false,
      "tension": 0.1
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processEngagementsVsRevenue.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'EngagementGraphLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "contentHeight": "480"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("\n              Sold out\n              "), (_vm.isSoldOutAveraging) ? _c('span', [_vm._v("average")]) : _vm._e(), _vm._v(" %\n            ")])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('horizontal-bar-chart', {
    attrs: {
      "showGridLines": true,
      "data": _vm.processSoldOut
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true,
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Advertisers")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processAdvertisers.length)) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['advertisers'].top), function(advertiser, index) {
    return _c('li', {
      key: advertiser.advertiser,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": advertiser.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(advertiser.advertiser))])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "scalesEnabled": false,
      "data": _vm.processAdvertisers
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processAdvertisers.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AdvertisersChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true,
      "contentHeight": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Advertising Categories")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processCategories.length)) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['categories'].top), function(category, index) {
    return _c('li', {
      key: category.category,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('div', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": category.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(_vm._s(category.category))])], 1)])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('analytics-chart', {
    attrs: {
      "type": "bar",
      "scalesEnabled": false,
      "data": _vm.processCategories
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processCategories.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'AdvertisersChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top 40 tracks")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['tracks'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['tracks'].top), function(track, index) {
    return _c('li', {
      key: track.track,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "track-position pull-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "pull-right text-right"
    }, [_c('growth', {
      attrs: {
        "value": track.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(track.count.toLocaleString()))])], 1), _vm._v(" "), _c('span', {
      staticClass: "track-artist text-muted"
    }, [_vm._v(_vm._s(track.artist))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(_vm._s(track.title))]), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })])])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top artists")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['artists'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['artists'].top), function(artist, index) {
    return _c('li', {
      key: artist.artist,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": artist.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(artist.artist))]), _vm._v(" "), _c('br')], 1)])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top genres")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['genres'].top.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "data": _vm.chartsData['genres'].top.map(function (s) { return [s.genre, s.count]; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['genres'].top.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['genres'].top), function(genre, index) {
    return _c('li', {
      key: genre.genre,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": genre.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(genre.genre))]), _vm._v(" "), _c('br')], 1)])
  }), 0)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top decades")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('ul', {
    staticClass: "list-group"
  }, [(Boolean(_vm.chartsData['decades'].top.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "data": _vm.chartsData['decades'].top.map(function (s) { return [s.decade, s.count]; })
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.chartsData['decades'].top.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e(), _vm._v(" "), (Boolean(_vm.chartsData['decades'].top.length)) ? _c('ul', _vm._l((_vm.chartsData['decades'].top), function(decade, index) {
    return _c('li', {
      key: decade.decade,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "artist-position pull-left text-bold"
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('span', [_c('growth', {
      staticClass: "pull-right",
      attrs: {
        "value": decade.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "track-artist"
    }, [_vm._v(_vm._s(decade.decade) + "'s")]), _vm._v(" "), _c('br')], 1)])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])])], 1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('i-box', [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Local vs International")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.processLocalVsInternational.length)) ? _c('analytics-chart', {
    attrs: {
      "type": "doughnut",
      "chartStyle": "max-height: 200px",
      "showLegend": false,
      "data": _vm.processLocalVsInternational
    }
  }) : _vm._e(), _vm._v(" "), (!Boolean(_vm.processLocalVsInternational.length)) ? _c('content-loader-placeholder', {
    attrs: {
      "slot": "content-loader",
      "type": 'DoughnutChartLoader'
    },
    slot: "content-loader"
  }) : _vm._e()], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('i-box', {
    attrs: {
      "noPadding": true
    }
  }, [_c('span', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h5', [_vm._v("Top Stations")])]), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [(Boolean(_vm.chartsData['stations'].top.length)) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.chartsData['stations'].top), function(station, index) {
    return _c('li', {
      key: station.station,
      staticClass: "list-group-item small track"
    }, [_c('span', {
      staticClass: "track-position pull-left"
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "pull-right text-right"
    }, [_c('growth', {
      attrs: {
        "value": station.change,
        "isPercentage": false
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "text-muted"
    }, [_vm._v(_vm._s(station.revenue.toLocaleString()))])], 1), _vm._v(" "), _c('span', {
      staticClass: "track-artist text-muted"
    }, [_vm._v(_vm._s(station.station))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
      staticClass: "track-title"
    }, [_vm._v(" ")])])])
  }), 0) : _c('content-loader-placeholder', {
    attrs: {
      "slot": "unit-content",
      "type": 'ListDividerLoader'
    },
    slot: "unit-content"
  })], 1)])], 1)])]) : _c('div', {
    staticStyle: {
      "padding-top": "12px"
    }
  }, [_c('div', {
    staticClass: "text-center ibox-content"
  }, [_c('h3', [_vm._v("Please contact ColonyLive sales team to activate this feature")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.promptMailToSale
    }
  }, [_vm._v("Contact Sales")])], 1), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": require("../../assets/images/afstereo-blurred.png"),
      "alt": "Afstereo dashboard blured"
    }
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6 afstereo-header"
  }, [_c('img', {
    staticClass: "afstereo-logo",
    attrs: {
      "src": require("../../assets/images/logos/AFSTEREO.PNG"),
      "alt": "AFSTEREO Logo"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "aircheck-logo",
    attrs: {
      "src": require("../../assets/images/logos/Aircheck.png"),
      "alt": "Aircheck Logo"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17a5561c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/analytics/AfstereoDashboard.vue
// module id = 3158
// module chunks = 3